import { MethodologyBackend } from '../../methodology/methodology';
import { ProductBackend } from '../../product/product';

export function getImprovedResponsePrompt(config: {
  goalDescription: string;
  methodology: MethodologyBackend;
  salesResponse: string;
  previousConversationList: string[];
  scenarioInstruction?: string;
  product?: ProductBackend;
}) {
  return `
Improve the following sales response:

<SALES_RESPONSE>
${config.salesResponse}
</SALES_RESPONSE>

Previous Conversation Context:
${config.previousConversationList.join('\n')}

Methodology:
${config.methodology.description}

Evaluation Criteria:
${config.methodology.subData.rubrics.join('\n')}

Goal: ${config.goalDescription}

Scenario: ${config.scenarioInstruction}

Product: ${config.product?.title}
${config.product?.description}

Objectives:
1. Align with the methodology
2. Achieve the stated goal
3. Adhere to the scenario
4. Engage the customer with insightful questions
5. Address customer needs comprehensively

Instructions:
1. Rewrite the sales response to optimize methodology alignment and goal achievement
2. Omit role identifiers (e.g., "Customer:", "Sales Rep:")
3. Provide only the final response, building on previous context
4. Include relevant product details if customer questions are unaddressed
`;
}

export function getSuggesionsPrompt(config: {
  goalDescription: string;
  methodology: MethodologyBackend;
  salesResponse: string;
  previousConversationList: string[];
  scenarioInstruction?: string;
  product?: ProductBackend;
}) {
  return `
Analyze the following sales response and provide key improvement areas:

<SALES_RESPONSE>
${config.salesResponse}
</SALES_RESPONSE>

Previous Conversation Context:
<PREVIOUS_CONVERSATION_CONTEXT>
${config.previousConversationList.join('\n')}
</PREVIOUS_CONVERSATION_CONTEXT>

Methodology and Goal:
<METHODOLOGY>
${config.methodology.description}
Key Evaluation Criteria:
${config.methodology.subData.rubrics.join('\n')}
</METHODOLOGY>

<GOAL>
${config.goalDescription}
</GOAL>

Scenario Instruction:
<SCENARIO_INSTRUCTION>
${config.scenarioInstruction}
</SCENARIO_INSTRUCTION>

Product:
<PRODUCT_TITLE>
${config.product?.title}
</PRODUCT_TITLE>
<PRODUCT_DESCRIPTION>
${config.product?.description}
</PRODUCT_DESCRIPTION>

Review the last sales response and conversation history between the Customer and Sales Rep carefully.
Assess if the Sales Rep achieved the specified goal applying the provided methodology.
In your output, you are talking to the sales rep in the conversation history. You are giving advice to the audience referred as "You".
Output in one paragraph, no more than 50 words. Do not list each of the criteria separately.
`;
}
// export function getAiFeedbackPrompt(config: {
//   goalDescription: string;
//   methodology: MethodologyBackend;
//   salesResponse: string;
//   previousConversationList: string[];
//   scenarioInstruction?: string;
//   product?: ProductBackend;
// }) {
//   return `
// Please analyze and enhance the following sales response:
// <SALES_RESPONSE>
// ${config.salesResponse}
// </SALES_RESPONSE>

// Previous Conversation Context:
// <PREVIOUS_CONVERSATION_CONTEXT>
// ${config.previousConversationList.join('\n')}
// </PREVIOUS_CONVERSATION_CONTEXT>

// Methodology and Goal:
// <METHODOLOGY>
// ${config.methodology.description}

// Key Evaluation Criteria:
// ${config.methodology.subData.rubrics.join('\n')}
// </METHODOLOGY>

// <GOAL>
// ${config.goalDescription}
// </GOAL>

// Scenario Instruction:
// <SCENARIO_INSTRUCTION>
// ${config.scenarioInstruction}
// </SCENARIO_INSTRUCTION>

// Product:
// <PRODUCT_TITLE>
// ${config.product?.title}
// </PRODUCT_TITLE>
// <PRODUCT_DESCRIPTION>
// ${config.product?.description}
// </PRODUCT_DESCRIPTION>

// Focus on:
// 1. Alignment with the provided methodology.
// 2. Effectiveness in achieving the stated goal.
// 3. Adherence to the scenario instruction.
// 4. Continue to engage the customer by asking insightful questions and addressing their needs.

// Ensure your feedback is constructive, actionable, and directly tied to the methodology and goal.

// Do the following:
// 1. Rewrite the sales response to follow the provided methodology and achieve the stated goal.
// 2. You must not start with "Customer:" or "Sales Rep:" or any role identifiers.
// 3. Only provide the last response as sales reps are expected to build on previous responses.
// 4. Provide the product detail if the sales response does not address the customer's quetsion.
// 5. Provide specific, actionable, direct, brief, concise feedback for further improvement.
// `;
// }

// export function getAiFeedbackPromptFunction() {
//   return [
//     {
//       name: 'rewrite_and_feedback_sales_response',
//       description: 'Rewrite the sales response and provide detailed, actionable feedback for improvement',
//       parameters: {
//         type: 'object',
//         properties: {
//           rewrittenResponse: {
//             type: 'string',
//             description: 'The improved version of the sales response',
//           },
//           improvementSuggestions: {
//             type: 'array',
//             items: { type: 'string' },
//             description: 'List of actionable suggestions for further improvement',
//           },
//         },
//         required: ['rewrittenResponse', 'improvementSuggestions'],
//       },
//     },
//   ];
// }
